// extracted by mini-css-extract-plugin
export default {"root":"History_root__3gkg0"};